<template>
  <div
    class="cadastro"
    v-if="!MostrarEncontroBoolean"
  >
    <div id="voltar">
      <h4>{{ isEmExecucao ? "Visualizar Atividade" : "Editar Atividade" }}</h4>
      <button @click.prevent="fecharModal()">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <div class="form">
      <div id="campos-form-container">
        <div id="campos-form">
          <section id="esquerda">
            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="nome"
                  class="form-label"
                  >Nome</label
                >
                <HelpIcon :texto="textosAjuda[0]" />
              </div>
              <input
                type="text"
                id="nome"
                class="form-control"
                v-model="formData.nome"
                :disabled="isEmExecucao"
              />
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="descricao"
                  class="form-label"
                  >Descrição</label
                >
                <HelpIcon :texto="textosAjuda[1]" />
              </div>
              <textarea
                id="descricao"
                class="form-control"
                v-model="formData.descricao"
                :disabled="isEmExecucao"
              ></textarea>
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="palavrasChave"
                  class="form-label"
                  >Palavras-chave</label
                >
                <HelpIcon :texto="textosAjuda[9]" />
              </div>
              <div class="input-group-palavras">
                <input
                  type="text"
                  id="palavrasChave"
                  class="form-control"
                  v-model="palavrasChaveInput"
                  placeholder="Digite uma palavra-chave (máx 50 caracteres)"
                  @keyup.enter="adicionarPalavraChave"
                  maxlength="50"
                  :disabled="isEmExecucao"
                />
                <button
                  type="button"
                  class="btn-adicionar-palavra"
                  @click="adicionarPalavraChave"
                  :disabled="isEmExecucao"
                >
                  Adicionar
                </button>
              </div>
            </div>

            <div
              id="div-palavras-chave"
              v-show="
                formData.palavrasChave && formData.palavrasChave.length > 0
              "
            >
              <h6>Palavras-chave Adicionadas:</h6>
              <div
                class="palavra-chave"
                v-for="(palavra, index) in formData.palavrasChave"
                :key="index"
              >
                <div>{{ palavra }}</div>
                <button
                  type="button"
                  class="remover-palavra"
                  @click="removerPalavraChave(index)"
                  :disabled="isEmExecucao"
                >
                  Remover
                </button>
              </div>
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="tipo"
                  class="form-label"
                  >Tipo</label
                >
                <HelpIcon :texto="textosAjuda[2]" />
              </div>
              <select
                id="tipo"
                class="form-select"
                v-model="tipoSelecionado"
                :disabled="isEmExecucao"
              >
                <option
                  v-for="tipo in Campos.tipos"
                  :key="tipo.id"
                  :value="tipo"
                >
                  {{ tipo.nome }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Subtipo*</label>

              <select
                class="form-select"
                v-model="formData.subtipoId"
                required
                :disabled="isEmExecucao"
              >
                <option
                  disabled
                  value=""
                >
                  Selecione um subtipo
                </option>
                <option
                  v-for="sub in tipoSelecionado?.subTipos"
                  :key="sub.id"
                  :value="sub.id"
                >
                  {{ sub.nome }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="tipo"
                  class="form-label"
                  >Selecione o(s) Objetivo(s) Específico(s) que esta
                  atividade contribui*</label
                >
                <HelpIcon :texto="textosAjuda[3]" />
              </div>
              <select
                id="tipo"
                class="form-select"
                v-model="objetivoSelecionado"
                @change="adicionarObjetivo"
                :disabled="isEmExecucao"
              >
                <option
                  v-for="objetivo in Campos.Objetivos"
                  :value="objetivo"
                >
                  {{ objetivo.titulo }}
                </option>
              </select>
            </div>

            <div
              id="div-objetivos"
              v-show="objetivosEscolhidos.length > 0"
            >
              <h6>Objetivos Selecionados:</h6>
              <div
                class="objetivo"
                v-for="(objetivo, index) in objetivosEscolhidos"
                :key="index"
              >
                <div>{{ objetivo.titulo }}</div>
                <button
                  class="remover-objetivo"
                  @click="removerObjetivo(index)"
                  :disabled="isEmExecucao"
                >
                  Remover Objetivo
                </button>
              </div>
            </div>
            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="imagem"
                  class="form-label"
                  >Imagem</label
                >
                <HelpIcon :texto="textosAjuda[7]"></HelpIcon>
              </div>
              <input
                type="file"
                id="imagem"
                class="form-control"
                accept="image/*"
                @change="processImage"
                :disabled="isEmExecucao"
              />
            </div>

            <div
              class="mb-3"
              v-if="imagemSelecionada"
            >
              <div class="imagem-preview-container">
                <img
                  :src="imagemSelecionada"
                  alt="Pré-visualização"
                  class="imagem-preview"
                />
                <button
                  class="btn-excluir-foto"
                  @click.prevent="removerFoto"
                  :disabled="isEmExecucao"
                >
                  Excluir Foto
                </button>
              </div>
            </div>

            <div
              class="mb-3"
              v-if="imagemSelecionada"
            >
              <div class="ajuda">
                <label
                  for="creditos-img"
                  class="form-label"
                  >Créditos da imagem</label
                >
                <HelpIcon :texto="textosAjuda[8]"></HelpIcon>
              </div>
              <input
                type="text"
                id="creditos-img"
                class="form-control"
                :disabled="isEmExecucao"
              />
            </div>
          </section>

          <section id="direita">
            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="modalidade-execucao"
                  class="form-label"
                  >Modalidade</label
                >
                <HelpIcon :texto="textosAjuda[4]" />
              </div>
              <select
                id="modalidade-execucao"
                class="form-select"
                v-model="formData.modalidadeExecucao"
                :disabled="isEmExecucao"
              >
                <option
                  v-for="modalidade in Campos.Modalidades"
                  :value="modalidade.value"
                >
                  {{ modalidade.nome }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="modalidade-inscricao"
                  class="form-label"
                  >Modalidade de Inscrição</label
                >
                <HelpIcon :texto="textosAjuda[5]" />
              </div>
              <select
                id="modalidade-inscricao"
                class="form-select"
                v-model="formData.modalidadeInscricao"
                :disabled="isEmExecucao"
              >
                <option
                  v-for="modalidadeInscricao in Campos.ModalidadesInscricao"
                  :value="modalidadeInscricao.value"
                >
                  {{ modalidadeInscricao.nome }}
                </option>
              </select>
            </div>

            <div v-if="formData.modalidadeInscricao === 'NESCESSITA_INSCRICAO'">
              <div id="datas">
                <div class="mb-3">
                  <label
                    for="dataInicioInscricao"
                    class="form-label"
                    >Data de Início das Inscrições</label
                  >
                  <input
                    type="datetime-local"
                    id="dataInicioInscricao"
                    class="form-control"
                    v-model="formData.dataInicioInscricao"
                    :disabled="isEmExecucao"
                  />
                </div>

                <div class="mb-3">
                  <label
                    for="dataFimInscricao"
                    class="form-label"
                    >Data de Fim das Inscrições</label
                  >
                  <input
                    type="datetime-local"
                    id="dataFimInscricao"
                    class="form-control"
                    v-model="formData.dataFimInscricao"
                    :disabled="isEmExecucao"
                  />
                </div>
              </div>

              <div class="mb-3">
                <label
                  for="criterioInscricao"
                  class="form-label"
                  >Critério de Inscrição</label
                >
                <select
                  id="criterioInscricao"
                  class="form-select"
                  v-model="formData.criterioInscricao"
                  :disabled="isEmExecucao"
                >
                  <option
                    v-for="criterio in Campos.CriteriosInscricao"
                    :value="criterio.value"
                  >
                    {{ criterio.nome }}
                  </option>
                </select>
              </div>

              <div
                v-if="formData.criterioInscricao === 'CRITERIODACOORDENACAO'"
              >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value="true"
                    id="flexCheckDefault"
                    v-model="inscricaoComFormulario"
                    :disabled="isEmExecucao"
                  />
                  <label
                    class="form-check-label"
                    for="flexCheckDefault"
                  >
                    Utilizar formulário de inscrição?
                  </label>
                </div>

                <div class="mb-3">
                  <label
                    for="nome"
                    class="form-label"
                    >Link formulário*</label
                  >
                  <input
                    type="text"
                    id="nome"
                    class="form-control"
                    v-model="formData.linkformulario"
                    :disabled="!inscricaoComFormulario || isEmExecucao"
                  />
                </div>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value="true"
                  id="flexCheckDefault"
                  v-model="vagasLimitadas"
                  :disabled="isEmExecucao"
                />
                <label
                  class="form-check-label"
                  for="flexCheckDefault"
                >
                  Limitar vagas?
                </label>
              </div>

              <div class="mb-3">
                <label
                  for="numeroDeVagasOfertadas"
                  class="form-label"
                  >Número de Vagas</label
                >
                <input
                  type="number"
                  id="numeroDeVagasOfertadas"
                  class="form-control"
                  v-model.number="formData.numeroDeVagasOfertadas"
                  min="1"
                  :disabled="!vagasLimitadas || isEmExecucao"
                />
              </div>
            </div>

            <div class="mb-3">
              <div class="ajuda">
                <label
                  for="local"
                  class="form-label"
                  >Local</label
                >
                <HelpIcon :texto="textosAjuda[6]"></HelpIcon>
              </div>
              <input
                type="text"
                id="local"
                class="form-control"
                v-model="formData.local"
                :disabled="isEmExecucao"
              />
            </div>
          </section>
        </div>

        <div id="botoes">
          <button
            id="excluir"
            @click.prevent="cancelarAtividade"
            :disabled="isEmExecucao"
          >
            Cancelar Atividade
          </button>
          <button
            v-if="!isEmExecucao"
            id="enviar"
            type="submit"
            class="btn btn-primary center"
            :disabled="atualizando"
            @click="handleSubmit"
          >
            Confirmar Edição da Atividade
          </button>
          <button
            id="salvar"
            @click.prevent="MostrarEncontroBoolean = true"
          >
            Editar Encontros
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="cadastro"
    v-else
  >
    <FormEditarEncontro
      @editar-atividade="MostrarEncontroBoolean = false"
      @fechar-form="$emit('fechar-form-atividade')"
      :encontros="formData.encontros"
      :atividadeId="atividadeId"
      :dadosAtividade="formData"
    />
  </div>
</template>

<script>
import FormEditarEncontro from "@/components/encontros/FormEditarEncontro.vue";
import HelpIcon from "@/components/common/HelpIcon.vue";
import atividadeService from "@/service/atividadeService";
import encontrosService from "@/service/encontrosService";
import objetivosService from "@/service/objetivosService";
import router from "@/router";
import { useRoute } from "vue-router";
import { formatarParaInputDateTimeLocal } from "@/utils/FormatarEntradas";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

function toUTC(date) {
  if (!date) return null;
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
}

export default {
  props: {
    atividadeId: String,
    acaoId: String,
    abrirEncontrosDireto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vagasLimitadas: false,
      MostrarEncontroBoolean: false,
      inscricaoComFormulario: false,
      atualizando: false,
      editarImagem: false,
      palavrasChaveInput: "",
      objetivosEscolhidos: [],
      objetivoSelecionado: {},
      imagemSelecionada: "",
      opcaoEdicaoImg: "nova-imagem",
      tipoSelecionado: null,
      route: useRoute(),

      formData: {
        nome: "",
        descricao: "",
        subtipo: "",
        subtipoId: null,
        modalidadeExecucao: "",
        modalidadeInscricao: "",
        local: "",
        acaoExtensaoId: "",
        dataInicioInscricao: "",
        dataFimInscricao: "",
        criterioInscricao: "",
        numeroDeVagasOfertadas: "",
        encontros: [],
        linkformulario: "",
        objetivos: [],
        palavrasChave: [],
        imagem: {
          mimeType: "",
          base64Data: "",
          creditosImagem: "",
        },
      },

      Campos: {
        Modalidades: [
          { value: "REMOTA", nome: "Remota" },
          { value: "PRESENCIAL", nome: "Presencial" },
          { value: "HIBRIDA", nome: "Híbrida" },
        ],
        ModalidadesInscricao: [
          { value: "NESCESSITA_INSCRICAO", nome: "Com Inscrição" },
          {
            value: "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA",
            nome: "Sem Inscrição (Com Frequência)",
          },
          {
            value: "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA",
            nome: "Sem Inscrição (Sem Frequência)",
          },
        ],
        CriteriosInscricao: [
          { value: "ORDEMDEINSCRICAO", nome: "Ordem de Inscrição" },
          { value: "CRITERIODACOORDENACAO", nome: "Critério da Coordenação" },
        ],
        Objetivos: [],
      },
      textosAjuda: [
        "Informe um título claro e objetivo para a atividade. Exemplos: Oficina de Fotografia Digital, Curso de Libras Básico.",
        "Descrição da atividade: o que será apresentado, quais os objetivos, quem pode participar, etc. Exemplo: O curso de Libras Básico tem como objetivo ensinar os fundamentos da Língua Brasileira de Sinais.",
        "Selecione a categoria que melhor representa a atividade",
        "Relacione todos os objetivos institucionais que esta atividade ajudará a alcançar. Você pode selecionar múltiplos objetivos",
        "Defina como a atividade será realizada: Presencial: Realizada fisicamente em local definido Remota: Realizada integralmente online Híbrida: Combina encontros presenciais e online",
        "Selecione o tipo de participação: Com Inscrição: Exige cadastro prévio dos participantes Sem Inscrição (Com Frequência): Aberta ao público, mas registra participantes Sem Inscrição (Sem Frequência): Aberta ao público sem registro",
        "Informe o local de realização com detalhes: Para atividades presenciais: Sala, bloco, Para online: Plataforma(s) utilizada(s) (ex: Google meet)",
        "Envie uma imagem representativa da atividade.",
        "Informe a quem pertence a imagem, ou quem queira se referir!",
        "Adicione palavras-chave para melhorar a busca e categorização da atividade. Cada palavra-chave pode ter no máximo 50 caracteres. Exemplos: educação, tecnologia, extensão.",
      ],
    };
  },
  methods: {
    formatarParaInputDateTimeLocal,

    adicionarObjetivo() {
      this.objetivosEscolhidos.push(this.objetivoSelecionado);
      const index = this.Campos.Objetivos.findIndex(
        (objetivo) => objetivo == this.objetivoSelecionado
      );
      this.Campos.Objetivos.splice(index, 1);
    },

    removerObjetivo(index) {
      const objetivo = this.objetivosEscolhidos[index];
      this.Campos.Objetivos.push(objetivo);
      this.objetivosEscolhidos.splice(index, 1);
      this.objetivoSelecionado = {};
    },

    adicionarPalavraChave() {
      const palavra = this.palavrasChaveInput.trim();

      // Validações
      if (!palavra) {
        alert("Por favor, digite uma palavra-chave");
        return;
      }

      if (palavra.length > 50) {
        alert("A palavra-chave não pode ter mais de 50 caracteres");
        return;
      }

      if (this.formData.palavrasChave.includes(palavra)) {
        alert("Esta palavra-chave já foi adicionada");
        return;
      }

      // Adicionar à lista
      this.formData.palavrasChave.push(palavra);
      this.palavrasChaveInput = "";
    },

    removerPalavraChave(index) {
      this.formData.palavrasChave.splice(index, 1);
    },

    async carregarObjetivosAtividade(atividadeId) {
      try {
        const objetivosAtividade =
          await objetivosService.getObjetivosAtividade(atividadeId);

        this.objetivosEscolhidos = objetivosAtividade || [];

        this.objetivosEscolhidos.map((objetivoAtividade) => {
          this.Campos.Objetivos = this.Campos.Objetivos.filter(
            (objetivoAcao) => objetivoAcao.id !== objetivoAtividade.id
          );
        });
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      try {
        this.atualizando = true;
        const atividadeId = this.formData.id;

        // Extrai o subtipoId independente de vir como objeto ou string
        const subtipoId =
          this.formData.subtipo && typeof this.formData.subtipo === "object"
            ? this.formData.subtipo.id
            : (this.formData.subtipoId ?? this.formData.subtipo);

        // Extrai acaoExtensaoId pelo mesmo motivo
        const acaoExtensaoId =
          this.formData.acaoExtensao &&
          typeof this.formData.acaoExtensao === "object"
            ? this.formData.acaoExtensao.id
            : this.formData.acaoExtensaoId;

        // Validar e preparar imagem
        let imagemPayload = null;
        const tiposPermitidos = ["image/jpeg", "image/png"];

        if (this.editarImagem && this.opcaoEdicaoImg === "apagar-imagem") {
          imagemPayload = null;
        } else if (this.editarImagem && this.formData.imagem?.base64Data) {
          // Validar tipo MIME antes de enviar
          if (!tiposPermitidos.includes(this.formData.imagem.mimeType)) {
            alert(
              `Tipo de imagem não suportado: ${this.formData.imagem.mimeType}.\nAceitamos apenas JPEG e PNG.`
            );
            this.atualizando = false;
            return;
          }
          imagemPayload = this.formData.imagem;
        } else if (this.formData.imagem?.base64Data && !this.editarImagem) {
          // Imagem antiga carregada - validar também
          if (!tiposPermitidos.includes(this.formData.imagem.mimeType)) {
            console.warn(
              `Tipo de imagem não suportado: ${this.formData.imagem.mimeType}. Será enviada como nula.`
            );
            imagemPayload = null;
          } else {
            imagemPayload = this.formData.imagem;
          }
        }

        // Base do payload
        const payload = {
          nome: this.formData.nome,
          descricao: this.formData.descricao,
          subtipo_id: subtipoId,
          modalidadeExecucao: this.formData.modalidadeExecucao,
          modalidadeInscricao: this.formData.modalidadeInscricao,
          criterioInscricao: this.formData.criterioInscricao || null,
          local: this.formData.local,
          acaoExtensaoId: acaoExtensaoId,
          numeroDeVagasOfertadas: this.formData.numeroDeVagasOfertadas || 0,
          linkFormulario: this.formData.linkformulario || null,
          encontros: [], // nunca enviar encontros existentes nesse form
          objetivos: this.objetivosEscolhidos.map((o) => o.id),
          palavrasChave: this.formData.palavrasChave || [],
          imagem: imagemPayload,
        };

        // Só enviar datas se a modalidade for COM INSCRIÇÃO
        if (this.formData.modalidadeInscricao === "NESCESSITA_INSCRICAO") {
          payload.dataInicioInscricao =
            toUTC(this.formData.dataInicioInscricao) || null;
          payload.dataFimInscricao =
            toUTC(this.formData.dataFimInscricao) || null;
        } else {
          // Se não for com inscrição, enviar null para limpar as datas
          payload.dataInicioInscricao = null;
          payload.dataFimInscricao = null;
        }

        await atividadeService.putAtividade(atividadeId, payload);
        this.$emit("recarregarAtividades");
        this.fecharModal();
      } catch (error) {
        console.log(error);
        alert("Erro ao atualizar atividade: " + error.message);
      }
      this.atualizando = false;
    },

    processImage(event) {
      const file = event.target.files[0];
      if (file) {
        // Validar tipo MIME - apenas JPEG e PNG são aceitos
        const tiposPermitidos = ["image/jpeg", "image/png"];
        if (!tiposPermitidos.includes(file.type)) {
          alert(
            `Tipo de arquivo não suportado: ${file.type}.\nAceitamos apenas JPEG e PNG.`
          );
          event.target.value = ""; // Limpar o input
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          this.formData.imagem.fileName = file.name;
          this.formData.imagem.mimeType = file.type;
          this.formData.imagem.base64Data = reader.result.split(",")[1];
          this.formData.imagem.creditosImagem =
            this.formData.imagem.creditosImagem || ""; // ← adicione isso
          this.imagemSelecionada = reader.result;
          this.editarImagem = true;
        };
        reader.onerror = () => alert("Erro ao processar a imagem.");
        reader.readAsDataURL(file);
      }
    },

    fecharModal() {
      router.back();
    },

    removerFoto() {
      this.imagemSelecionada = "";
      this.formData.imagem = {
        fileName: "",
        mimeType: "",
        base64Data: "",
      };
      this.editarImagem = true;
      this.opcaoEdicaoImg = "apagar-imagem";
      const fileInput = document.getElementById("imagem");
      if (fileInput) {
        fileInput.value = "";
      }
    },

    async processarImagemAtividade(atividade) {
      let dadosImagem = {
        mimeType: "",
        base64Data: "",
        creditosImagem: atividade?.imagem?.creditosImagem || "",
      };
      try {
        if (!atividade?.imagemUrl) {
          return dadosImagem;
        }

        const response = await fetch(atividade.imagemUrl);
        const blob = await response.blob();

        // Validar tipo MIME da imagem existente
        const tiposPermitidos = ["image/jpeg", "image/png"];
        if (!tiposPermitidos.includes(blob.type)) {
          console.warn(
            `Tipo MIME da imagem não suportado: ${blob.type}. Será ignorada.`
          );
          return dadosImagem;
        }

        dadosImagem.mimeType = blob.type;

        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        dadosImagem.base64Data = base64.split(",")[1];
        dadosImagem.creditosImagem = atividade.creditosImagem || ""; // ← adicione isso
        dadosImagem.base64Data = base64.split(",")[1];
        this.imagemSelecionada = base64;
      } catch (error) {
        console.log("Erro ao processar imagem existente:", error);
      }

      return dadosImagem;
    },

    async cancelarAtividade() {
      const confirmacao = confirm(
        "Você tem certeza que deseja cancelar essa atividade? Esta ação não pode ser desfeita."
      );
      if (confirmacao) {
        const atividadeId = this.formData.id;
        const mensagem = prompt(
          "Digite o motivo do cancelamento dessa atividade"
        );
        if (mensagem !== null) {
          await atividadeService.cancelarAtividade(atividadeId, mensagem);
          this.$emit("recarregarAtividades");
          this.fecharModal();
        }
      }
    },

    async carregarAtividade(atividadeId) {
      let atividade = null;
      try {
        atividade = await atividadeService.getAtividadeId(atividadeId);
        if (atividade) {
          if (atividade.dataInicioInscricao) {
            atividade.dataInicioInscricao = this.formatarParaInputDateTimeLocal(
              atividade.dataInicioInscricao
            );
          }
          if (atividade.dataFimInscricao) {
            atividade.dataFimInscricao = this.formatarParaInputDateTimeLocal(
              atividade.dataFimInscricao
            );
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        const imagem = await this.processarImagemAtividade(atividade);
        if (atividade) {
          atividade.imagem = imagem;
        }
        return atividade;
      }
    },

    async carregarTipos() {
      const tiposAtividade = await atividadeService.getTiposeSubtipos();

      this.Campos.tipos = tiposAtividade.map((tipo) => ({
        id: tipo.id,
        nome: tipo.nome,
        subTipos: tipo.subTipos,
      }));

      // Era: subtipo.id = this.formData.subtipoId  ← assignment, bug!
      // subtipoId pode vir como objeto da API, por isso o fallback com optional chaining
      const subtipoIdAtual =
        typeof this.formData.subtipo === "object"
          ? this.formData.subtipo?.id
          : this.formData.subtipoId;

      tiposAtividade.forEach((tipo) => {
        if (tipo.subTipos.some((subtipo) => subtipo.id === subtipoIdAtual)) {
          this.tipoSelecionado = tipo;
        }
      });
    },

    async carregarEncontros(atividadeId) {
      this.formData.encontros = await encontrosService.getEncontros(
        0,
        100,
        atividadeId
      );
    },
  },

  computed: {
    isEmExecucao() {
      return this.formData?.status === "EM_EXECUCAO";
    },
  },

  watch: {
    vagasLimitadas(newVagasLimitadas) {
      if (!newVagasLimitadas) {
        this.formData.numeroDeVagasOfertadas = null;
      }
    },
  },

  components: {
    FormEditarEncontro,
    HelpIcon,
  },

  async mounted() {
    if (this.abrirEncontrosDireto) {
      this.MostrarEncontroBoolean = true;
    }

    document.body.classList.add("modal-aberto");

    const atividadeId =
      this.route.query.atividade ||
      this.route.query.atividadeId ||
      this.atividadeId;

    this.formData = await this.carregarAtividade(atividadeId);

    await this.carregarEncontros(atividadeId);
    await this.carregarTipos();
    await this.carregarObjetivosAtividade(atividadeId);

    this.Campos.Objetivos = await objetivosService.getObjetivosAcao(
      this.acaoId
    );

    if (this.formData.numeroDeVagasOfertadas > 0) {
      this.vagasLimitadas = true;
    }
    if (this.formData?.linkFormulario != "" && this.formData?.linkFormulario) {
      this.inscricaoComFormulario = true;
    }
  },

  beforeUnmount() {
    document.body.classList.remove("modal-aberto");
  },
};
</script>

<style scoped>
#form {
  min-height: 3500px;
}

#campos-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  width: 100%;
}

.form-check-input {
  border: 2px solid #6f319aff;
}

#cadastro {
  z-index: 10;
}

#imgs {
  display: flex;
  flex-direction: column;
}

#imgs img {
  width: 100%;
  border-radius: 25px;
}

#imgs div {
  background-color: #e5dbfaff;
  padding: 2%;
  border-radius: 25px;
  margin: 0.5%;
  border: 2px solid #6f319e;
}

#excluir {
  background-color: red;
  border-color: red;
  color: white;
}

#botoes button {
  width: auto;
}

#edicao-nav {
  display: flex;
  position: absolute;
  top: 0;
  width: 100%;
  height: 40px;
}

.botao-nav {
  border: none;
  background-color: white;
  width: 100%;
  height: 40px;
  border-bottom: 2px solid #1d123bff;
}

.botao-nav:hover {
  background-color: #6f319e6a;
  color: white;
  transition: 450ms;
}

.edicao-select {
  background-color: rgba(29, 18, 59, 0.803);
  color: white;
}

.ajuda {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.input-group-palavras {
  display: flex;
  gap: 8px;
  align-items: center;
}

.input-group-palavras input {
  flex: 1;
}

.btn-adicionar-palavra {
  padding: 8px 16px;
  background-color: #6f319aff;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.btn-adicionar-palavra:hover {
  background-color: #5a2680;
}

#div-palavras-chave {
  margin-top: 12px;
}

#div-palavras-chave h6 {
  margin-bottom: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #000;
}

.palavra-chave {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  gap: 8px;
}

.palavra-chave div {
  flex: 1;
  color: #333;
  word-break: break-word;
}

.remover-palavra {
  padding: 4px 12px;
  background-color: #ff4444;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.remover-palavra:hover {
  background-color: #cc0000;
}

.imagem-preview-container {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 8px;
  border: 1px dashed #ced4da;
}

.imagem-preview {
  width: 80px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.btn-excluir-foto {
  margin-left: auto;
  padding: 6px 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-excluir-foto:hover {
  background-color: #bd2130;
}

.objetivo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  gap: 8px;
}

.objetivo div {
  flex: 1;
  color: #333;
  word-break: break-word;
}

.remover-objetivo {
  padding: 4px 12px;
  background-color: #ff4444;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.remover-objetivo:hover {
  background-color: #cc0000;
}
</style>
